

require('./bootstrap')


import Vue from 'vue'

import NavigationHeader from './components/admin-layout/navigation-header'

import FormError from "./components/elements/FormError";
import Flash from './components/admin-layout/flash';
import LiveSearch from "./components/LiveSearch";
import LiveElement from "./components/sandbox/live-element"
import ItemForm from "./components/ItemForm";
import PhotoUpload from "./components/PhotoUpload";
import UserProfile from "./components/users/UserProfile";
import PayloadList from "./components/PayloadList";
import VueSweetalert2 from 'vue-sweetalert2';
import PayloadItem from "./components/payloads/PayloadItem";
import PayloadsCounter from "./components/payloads/PayloadsCounter";
import Editor from '@tinymce/tinymce-vue'
import 'sweetalert2/dist/sweetalert2.min.css';
import MyTransition from "./components/elements/MyTransition";
import PartsRequest from "./components/machinery_items/PartsRequest";
import { ZiggyVue } from 'ziggy-js/dist/vue';
import { Ziggy } from './ziggy';
import RefreshItem from "./components/RefreshItem";
import IonSlider from "./components/elements/IonSlider";

Ziggy.url = ''; // Для относительных путей
Vue.use(VueSweetalert2);

Vue.use(ZiggyVue, Ziggy);

require('./vue-tailwind-init')



// const app = new Vue({
let app = new Vue({
    el: '#app',

    components: {
        'item-form': ItemForm,
        'navigation-header': NavigationHeader,
        'user-profile': UserProfile,
        'parts-request': PartsRequest,
        'flash': Flash,
        'live-search': LiveSearch,
        'live-element': LiveElement,
        'photo-upload': PhotoUpload,
        'form-error': FormError,
        'editor': Editor,
        'payload-list': PayloadList,
        'payloads-counter': PayloadsCounter,
        'payload-item': PayloadItem,
        'my-transition': MyTransition,
        'refresh-item': RefreshItem,
        'ion-slider': IonSlider,
    },
})

// require('livewire-vue')
// window.Vue = Vue










